import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { cn } from "~/lib/utils";

export interface SliderProps extends React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> {
  trackClassName?: string;
  rangeClassName?: string;
  thumbClassName?: string;
  /** Accessible name for the thumb — Radix puts role="slider" on the thumb, not the root. */
  thumbLabel?: string;
}

// Single-thumb Radix slider. Defaults match the Fleet Quote Builder (13px track,
// 24px Navy thumb); every part takes a className to restyle it.
const Slider = React.forwardRef<React.ElementRef<typeof SliderPrimitive.Root>, SliderProps>(
  ({ className, trackClassName, rangeClassName, thumbClassName, thumbLabel, ...props }, ref) => (
    <SliderPrimitive.Root
      ref={ref}
      className={cn("relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50", className)}
      {...props}
    >
      <SliderPrimitive.Track className={cn("relative h-[13px] w-full grow overflow-hidden rounded-2xl bg-white", trackClassName)}>
        <SliderPrimitive.Range className={cn("bg-bouncie-500 absolute h-full rounded-2xl", rangeClassName)} />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        aria-label={thumbLabel}
        className={cn(
          "bg-bouncie-900 focus-visible:ring-bouncie-500 block size-6 cursor-grab rounded-full focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none active:cursor-grabbing",
          thumbClassName,
        )}
      />
    </SliderPrimitive.Root>
  ),
);
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
